export default __webpack_public_path__ + "images/loggedout/icons/at_home_icon-2e013565ccb7813f0c15dac23921f93d.png";